const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M11.424 24q0 1.44-0.992 2.432t-2.432 0.992-2.432-0.992-0.992-2.432q0-1.088 0.608-1.952t1.664-1.28v-16.192h2.304v16.192q1.024 0.384 1.664 1.28t0.608 1.952zM13.728 24q0-1.376-0.608-2.56t-1.696-2.016v-13.696q0-1.44-0.992-2.432t-2.432-1.024-2.432 1.024-0.992 2.432v13.696q-1.088 0.8-1.696 2.016t-0.608 2.56q0 2.368 1.696 4.032t4.032 1.696 4.032-1.696 1.696-4.032zM16 24q0 3.296-2.336 5.664t-5.664 2.336-5.664-2.336-2.336-5.664q0-3.264 2.272-5.6v-12.672q0-2.4 1.696-4.064t4.032-1.664 4.032 1.664 1.696 4.064v12.672q2.272 2.336 2.272 5.6zM18.272 13.728v2.272h-3.424v-2.272h3.424zM18.272 9.152v2.272h-3.424v-2.272h3.424zM18.272 4.576v2.272h-3.424v-2.272h3.424z"
});

const SvgThermometer = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-thermometer",
    viewBox: "0 0 16 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThermometer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thermometer.8d362cd4.svg";
export { ForwardRef as ReactComponent };